import * as React from 'react';
import { get } from 'lodash';
import { Grid, Col, Row } from 'react-flexbox-grid';
import { Card } from 'material-ui';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

const LocalLookupDetail: React.SFC<any> = ({ person }) => (
  <Card style={{ padding: '15px', margin: '15px 0' }}>
    <Row style={{ paddingBottom: '15px' }}>
      <Col md={6}>
        <Row>
          <Col md={4}>
            <div style={{ fontWeight: 'bold' }}>Jméno:</div>
          </Col>
          <Col md={8}>
            <div style={{ textAlign: 'right' }}>{get(person, 'fullName')}</div>
          </Col>
        </Row>
      </Col>
      <Col md={6}>
        <Row>
          <Col md={6}>
            <div style={{ fontWeight: 'bold' }}>Adresa:</div>
          </Col>
          <Col md={6}>
            <div style={{ textAlign: 'right' }}>{get(person, 'address.fullAddress', 'Neznámo')}</div>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row>
      <Col md={6}>
        <Row>
          <Col md={6}>
            <div style={{ fontWeight: 'bold' }}>Datum Narození:</div>
          </Col>
          <Col md={6}>
            <div style={{ textAlign: 'right' }}>{get(person, 'birthDate', 'Neznámo')}</div>
          </Col>
        </Row>
      </Col>
      <Col md={6}>
        <Row>
          <Col md={6}>
            <div style={{ fontWeight: 'bold' }}>Rodné Číslo:</div>
          </Col>
          <Col md={6}>
            <div style={{ textAlign: 'right' }}>{get(person, 'birthNumber', 'Neznámo')}</div>
          </Col>
        </Row>
      </Col>
    </Row>
  </Card>
);

export const LocalLookupsForm = ({ items, closeItem }) => (
  <div style={{ margin: '15px' }}>
    <Grid fluid={true}>
      <Card
        style={{
          height: '300px',
          overflow: 'auto'
        }}
      >
        {items.map((o, i) => (
          <LocalLookupDetail key={i} {...o} />
        ))}
        {!items.length && <h4>Žádná osoba nebyla nalezena</h4>}
      </Card>
    </Grid>
    <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/person/LocalLookupsForm.tsx